import React, { useEffect } from 'react';
import './Support.css';

function Support() {
    useEffect(() => { window.scrollTo(0, 0); }, []);

    return (
        <div className='support-wrapper'>
            <div className='support-card'>
                <i className="bi bi-envelope-fill support-icon mb-3 d-block"></i>
                <h5 className='fw-semibold mb-1'>Contact Support</h5>
                <p className='text-muted font-14 mb-3'>
                    For any support or queries, reach out via email. Basic troubleshooting and setup guidance available.
                </p>
                <p className='font-14 mb-1'><i className="bi bi-building me-2 text-info"></i>360 Degree Cloud Technologies</p>
                <p className='font-14 mb-1'><i className="bi bi-clock me-2 text-info"></i>Response Time: 24–48 business hours</p>
                <p className='font-14 mb-3'>
                    <i className="bi bi-envelope me-2 text-info"></i>
                    <a href="mailto:support@360degreeapps.com" className='link-info'>support@360degreeapps.com</a>
                </p>
                <a href="mailto:support@360degreeapps.com" className='btn btn-outline-info btn-sm'>
                    <i className="bi bi-send me-2"></i>Send us an Email
                </a>
            </div>
        </div>
    );
}

export default Support;